export default __webpack_public_path__ + "static/media/tallpottedplant.b36bc169.png";